// extracted by mini-css-extract-plugin
module.exports = {"drag":"MediaLibraryPage_drag__zplPD","empty":"MediaLibraryPage_empty__1yNYo"};